export default `
.content-header-section {
  background-color: #f4f4f7;
  padding: 8px 0;
}

.navbar-brand img {
  height: 30px;
}

/* Modern renk paleti */
:root {
  --primary-color: #6366F1;
  --primary-dark: #4F46E5;
  --success-color: #10B981;
  --danger-color: #EF4444;
  --warning-color: #F59E0B;
  --gray-50: #F8FAFC;
  --gray-100: #F1F5F9;
  --gray-200: #E2E8F0;
  --gray-300: #CBD5E1;
  --gray-400: #94A3B8;
  --gray-600: #475569;
  --gray-700: #334155;
  --gray-800: #1E293B;
  --gray-900: #0F172A;
}

/* Identity Module Button Overrides */
abp-users .entry-row .btn-primary,
abp-roles .entry-row .btn-primary,
.entry-row .btn-primary,
.col-auto > .btn-primary,
.text-right > .btn-primary,
.text-end > .btn-primary {
  background: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  padding: 0.75rem 1.5rem !important;
  min-width: 140px !important;
  height: auto !important;
  line-height: 1.5 !important;
  font-weight: 500 !important;
  font-size: 1rem !important;
  border-radius: 0.5rem !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0.5rem !important;
}

abp-users .entry-row .btn-primary:hover,
abp-roles .entry-row .btn-primary:hover {
  background: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3) !important;
}

/* Confirmation Dialog Styles - More Specific Selectors */
body abp-confirmation .modal-dialog .modal-content,
body .modal:has(abp-confirmation) .modal-content,
body .abp-confirm .modal-content,
body .modal.confirmation .modal-content,
body [id*="modal"] .modal-content:has(.confirmation-message) {
  border: none !important;
  border-radius: 1rem !important;
  overflow: hidden !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
}

body abp-confirmation .modal-dialog .modal-header,
body .modal:has(abp-confirmation) .modal-header,
body .abp-confirm .modal-header,
body .modal.confirmation .modal-header,
body [id*="modal"] .modal-header:has(+ .modal-body .confirmation-message) {
  background: linear-gradient(135deg, var(--warning-color) 0%, #DC2626 100%) !important;
  color: white !important;
  padding: 1.25rem 1.5rem !important;
  border: none !important;
  border-bottom: none !important;
}

body abp-confirmation .modal-title,
body .modal:has(abp-confirmation) .modal-title,
body .abp-confirm .modal-title,
body .modal.confirmation .modal-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  color: white !important;
  display: flex !important;
  align-items: center !important;
  gap: 0.75rem !important;
}

body abp-confirmation .modal-title::before,
body .modal:has(abp-confirmation) .modal-title::before {
  content: "⚠️" !important;
  font-size: 1.5rem !important;
}

body abp-confirmation button.close,
body .modal:has(abp-confirmation) button.close,
body abp-confirmation .btn-close,
body .modal:has(abp-confirmation) .btn-close {
  color: white !important;
  opacity: 0.8 !important;
  text-shadow: none !important;
  filter: brightness(0) invert(1) !important;
}

body abp-confirmation button.close span,
body .modal:has(abp-confirmation) button.close span {
  color: white !important;
}

body abp-confirmation .modal-body,
body .modal:has(abp-confirmation) .modal-body,
body .abp-confirm .modal-body,
body .modal.confirmation .modal-body {
  padding: 2rem !important;
  font-size: 1.1rem !important;
  color: var(--gray-700) !important;
  text-align: center !important;
  background: white !important;
}

body abp-confirmation .modal-footer,
body .modal:has(abp-confirmation) .modal-footer,
body .abp-confirm .modal-footer,
body .modal.confirmation .modal-footer {
  background: var(--gray-50) !important;
  border: none !important;
  border-top: 1px solid var(--gray-200) !important;
  padding: 1.25rem 1.5rem !important;
  gap: 0.75rem !important;
  display: flex !important;
  justify-content: center !important;
}

body abp-confirmation .modal-footer .btn,
body .modal:has(abp-confirmation) .modal-footer .btn,
body .abp-confirm .modal-footer .btn {
  padding: 0.625rem 1.5rem !important;
  border-radius: 0.5rem !important;
  font-weight: 600 !important;
  min-width: 100px !important;
}

body abp-confirmation .btn-secondary,
body .modal:has(abp-confirmation) .btn-secondary,
body .abp-confirm .btn-secondary {
  background: white !important;
  color: var(--gray-700) !important;
  border: 2px solid var(--gray-300) !important;
}

body abp-confirmation .btn-secondary:hover,
body .modal:has(abp-confirmation) .btn-secondary:hover {
  background: var(--gray-100) !important;
  border-color: var(--gray-400) !important;
}

body abp-confirmation .btn-primary,
body abp-confirmation .btn-danger,
body .modal:has(abp-confirmation) .btn-primary,
body .modal:has(abp-confirmation) .btn-danger,
body .abp-confirm .btn-primary,
body .abp-confirm .btn-danger {
  background: var(--danger-color) !important;
  color: white !important;
  border: none !important;
}

body abp-confirmation .btn-primary:hover,
body abp-confirmation .btn-danger:hover,
body .modal:has(abp-confirmation) .btn-primary:hover,
body .modal:has(abp-confirmation) .btn-danger:hover {
  background: #DC2626 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

/* Toast Notification Styles */
abp-toast-container .toast {
  border-radius: 0.75rem !important;
  border: none !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden !important;
}

abp-toast-container .toast-header.bg-success {
  background: var(--success-color) !important;
  color: white !important;
}

abp-toast-container .toast-header.bg-danger {
  background: var(--danger-color) !important;
  color: white !important;
}

abp-toast-container .toast-header.bg-warning {
  background: var(--warning-color) !important;
  color: white !important;
}

abp-toast-container .toast-header.bg-info {
  background: var(--primary-color) !important;
  color: white !important;
}

abp-toast-container .toast-body {
  padding: 1rem 1.25rem !important;
  color: var(--gray-700) !important;
  font-size: 0.95rem !important;
}

/* General Primary Button Override */
.btn-primary:not(.btn-group .btn):not(.btn-sm):not(.btn-lg) {
  background: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  padding: 0.75rem 1.5rem !important;
  min-width: 140px !important;
  font-weight: 500 !important;
  border-radius: 0.5rem !important;
}

.btn-primary:not(.btn-group .btn):hover {
  background: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}

/* Loading Bar */
abp-loader-bar .abp-progress {
  background: var(--primary-color) !important;
  height: 3px !important;
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.5) !important;
}

/* ABP Spinner */
.abp-spinner {
  border-color: rgba(99, 102, 241, 0.2) !important;
  border-top-color: var(--primary-color) !important;
}

/* Force Confirmation Dialog Styles with ID Selectors */
#abp-confirm-modal .modal-header,
#abp-modal-header {
  background: linear-gradient(135deg, var(--warning-color) 0%, #DC2626 100%) !important;
  color: white !important;
  padding: 1.25rem 1.5rem !important;
  border: none !important;
}

#abp-confirm-modal .modal-title,
.abp-confirm-modal .modal-title {
  color: white !important;
  font-weight: 600 !important;
}

#abp-confirm-modal .close,
#abp-confirm-modal .btn-close,
#abp-modal-close-button {
  color: white !important;
  opacity: 0.8 !important;
  filter: brightness(0) invert(1) !important;
}

#abp-confirm-modal .modal-body,
#abp-modal-body {
  text-align: center !important;
  padding: 2rem !important;
  font-size: 1.1rem !important;
}

#abp-confirm-modal .modal-footer,
#abp-modal-footer {
  background: var(--gray-50) !important;
  border-top: 1px solid var(--gray-200) !important;
  justify-content: center !important;
  padding: 1.25rem !important;
}

/* All ABP Modals General Styling */
.modal.show .modal-dialog {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* ABP Default Modal Override */
[class*="abp-"] .modal-content,
abp-modal .modal-content {
  border-radius: 1rem !important;
  border: none !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
}

/* Global Modal Close Button Fix - White X icon on gradient headers */
#abp-modal-header #abp-modal-close-button,
#abp-modal-header .btn-close,
.abp-modal-header #abp-modal-close-button,
.abp-modal-header .btn-close,
button#abp-modal-close-button,
button.btn-close.btn-sm,
.modal-header .btn-close,
.modal-header .close,
.modal-header button.close,
.modal-header #abp-modal-close-button,
.modal-header button[class*="close"],
abp-modal .modal-header .btn-close,
abp-modal .modal-header button.close,
[class*="abp-"] .modal-header .btn-close,
[class*="abp-"] .modal-header button.close {
  background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat !important;
  opacity: 0.9 !important;
  width: 2rem !important;
  height: 2rem !important;
  min-width: 2rem !important;
  min-height: 2rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border: none !important;
  padding: 0.5rem !important;
  box-sizing: content-box !important;
  transition: all 0.2s !important;
}

#abp-modal-header #abp-modal-close-button:hover,
#abp-modal-header .btn-close:hover,
.abp-modal-header #abp-modal-close-button:hover,
.abp-modal-header .btn-close:hover,
button#abp-modal-close-button:hover,
button.btn-close.btn-sm:hover,
.modal-header .btn-close:hover,
.modal-header .close:hover,
.modal-header button.close:hover,
.modal-header #abp-modal-close-button:hover,
abp-modal .modal-header .btn-close:hover,
abp-modal .modal-header button.close:hover {
  opacity: 1 !important;
  background: rgba(255, 255, 255, 0.15) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat !important;
}

/* Confirmation Specific - Target by Text Content */
.modal-body:has(p:contains("unsaved changes")),
.modal-body:has(p:contains("Are you sure")),
.modal-body:has(.confirmation-message) {
  text-align: center !important;
  font-size: 1.1rem !important;
}

.modal-header:has(+ .modal-body p:contains("unsaved changes")),
.modal-header:has(+ .modal-body p:contains("Are you sure")),
.modal-header:has(+ .modal-body .confirmation-message) {
  background: linear-gradient(135deg, var(--warning-color) 0%, #DC2626 100%) !important;
  color: white !important;
}

/* ABP Confirmation Dialog Styles - Correct Structure */
abp-confirmation .confirmation {
  z-index: 1050 !important;
}

abp-confirmation .confirmation-backdrop {
  background: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(4px) !important;
}

abp-confirmation .confirmation-dialog {
  background: white !important;
  border-radius: 1rem !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
  overflow: hidden !important;
  max-width: 500px !important;
  animation: confirmationSlideIn 0.3s ease-out !important;
}

/* Icon Container Styles */
abp-confirmation .icon-container {
  width: 80px !important;
  height: 80px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 2rem auto 1.5rem auto !important;
  font-size: 2.5rem !important;
  color: white !important;
}

abp-confirmation .icon-container.warning {
  background: linear-gradient(135deg, var(--warning-color) 0%, #DC2626 100%) !important;
  box-shadow: 0 8px 24px rgba(245, 158, 11, 0.4) !important;
}

abp-confirmation .icon-container.error {
  background: linear-gradient(135deg, var(--danger-color) 0%, #B91C1C 100%) !important;
  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.4) !important;
}

abp-confirmation .icon-container.success {
  background: linear-gradient(135deg, var(--success-color) 0%, #059669 100%) !important;
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4) !important;
}

abp-confirmation .icon-container.info {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%) !important;
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.4) !important;
}

abp-confirmation .icon-container i {
  color: white !important;
  font-size: inherit !important;
}

/* Content Styles */
abp-confirmation .content {
  padding: 0 2rem !important;
  text-align: center !important;
}

abp-confirmation .content .title {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: var(--gray-900) !important;
  margin-bottom: 0.75rem !important;
}

abp-confirmation .content .message {
  font-size: 1.1rem !important;
  color: var(--gray-700) !important;
  line-height: 1.6 !important;
  margin-bottom: 2rem !important;
}

/* Footer/Button Styles */
abp-confirmation .footer {
  padding: 1.5rem 2rem !important;
  background: var(--gray-50) !important;
  border-top: 1px solid var(--gray-200) !important;
  display: flex !important;
  justify-content: center !important;
  gap: 1rem !important;
}

abp-confirmation .footer .btn {
  padding: 0.75rem 2rem !important;
  border-radius: 0.5rem !important;
  font-weight: 600 !important;
  min-width: 120px !important;
  transition: all 0.3s !important;
  border: none !important;
}

abp-confirmation .footer .btn-secondary {
  background: white !important;
  color: var(--gray-700) !important;
  border: 2px solid var(--gray-300) !important;
}

abp-confirmation .footer .btn-secondary:hover {
  background: var(--gray-100) !important;
  border-color: var(--gray-400) !important;
  transform: translateY(-1px) !important;
}

abp-confirmation .footer .btn-primary {
  background: var(--danger-color) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

abp-confirmation .footer .btn-primary:hover {
  background: #DC2626 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

/* Animation */
@keyframes confirmationSlideIn {
  from {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

/* Force all confirmation modals to have gradient header */
.modal-dialog:has(.icon-container.warning) .modal-header,
.modal-dialog:has(.confirmation-message) .modal-header {
  background: linear-gradient(135deg, var(--warning-color) 0%, #DC2626 100%) !important;
  color: white !important;
  padding: 1.25rem 1.5rem !important;
  border: none !important;
}

.modal-dialog:has(.icon-container.warning) .modal-title,
.modal-dialog:has(.confirmation-message) .modal-title {
  color: white !important;
  font-weight: 600 !important;
}

.modal-dialog:has(.icon-container.warning) .close,
.modal-dialog:has(.icon-container.warning) .btn-close,
.modal-dialog:has(.confirmation-message) .close,
.modal-dialog:has(.confirmation-message) .btn-close {
  color: white !important;
  opacity: 0.8 !important;
  text-shadow: none !important;
  filter: brightness(0) invert(1) !important;
}

.modal-dialog:has(.icon-container.warning) .close span,
.modal-dialog:has(.confirmation-message) .close span {
  color: white !important;
}

.modal-dialog:has(.icon-container.warning) .modal-footer,
.modal-dialog:has(.confirmation-message) .modal-footer {
  background: var(--gray-50) !important;
  border-top: 1px solid var(--gray-200) !important;
  padding: 1.25rem !important;
  justify-content: center !important;
}

/* Target modals with specific button combinations */
.modal-footer:has(.btn-secondary):has(.btn-primary),
.modal-footer:has(.btn-secondary):has(.btn-danger) {
  background: var(--gray-50) !important;
  justify-content: center !important;
  gap: 0.75rem !important;
}

.modal-footer:has(.btn-secondary):has(.btn-primary) .btn-primary,
.modal-footer:has(.btn-secondary):has(.btn-danger) .btn-danger {
  background: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
  color: white !important;
}

.modal-footer:has(.btn-secondary):has(.btn-primary) .btn-primary:hover,
.modal-footer:has(.btn-secondary):has(.btn-danger) .btn-danger:hover {
  background: #DC2626 !important;
  border-color: #DC2626 !important;
}
`;
